// extracted by mini-css-extract-plugin
export default {"dropdown":"decoration-dropdown_dropdown__DYky+","menu":"decoration-dropdown_menu__5zMRZ"};